import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ErrorHandlingService } from '../general/error-handling.service';
import { keysToLowerCase } from 'src/app/utils/json.util';

@Injectable({
  providedIn: 'root'
})
export class ResultsSkillService {

  backendUrl:string = environment.backendUrl; 

  constructor(private http: HttpClient, private errorHandlingService: ErrorHandlingService) {}

  getResultsSkillData(practiceCallUuid:string, promptType:string): Observable<any> {
    return this.http
      .get<any>(`${this.backendUrl}/results/practiceCallAnalysis/?practiceCallUuid=${practiceCallUuid}&promptType=${promptType}`)
      .pipe(
        map((result) => {
          // lowercasing and removing whitespaces for Skill Details and
          // the same for every JSON inside the array of Skill Details (skilldetails)
          try {
            if (!result) return result;
            const lowerCaseJson = keysToLowerCase(JSON.parse(result.contentDetails));
            const skillDetailsJson = lowerCaseJson.skilldetails || [];
            skillDetailsJson.forEach((skill: any, index: number) => {
              skillDetailsJson[index] = keysToLowerCase(skill);
            });
            lowerCaseJson.skilldetails = skillDetailsJson;
            result.contentDetails = JSON.stringify(lowerCaseJson);
            return result;
          } catch(error) {
            console.error('Error parsing or processing SkillResults JSON:', error);
            throw error; // Rethrowing the error to be caught by catchError
          }
        }),
        tap((res) => {
          const outcome = res ? 'fetched' : 'did not find';
          console.log(`skill results: ${outcome}`);
        }),
        catchError((error) => {
          if (error.status === 500) {
            console.error('Error:', error);
            throw error;
          } else {
            return this.errorHandlingService.handleError<any>(`skill_results`)(error);
          }
        }),
      );
  }
}
